import React, { useEffect, useState } from "react";
import Axios from "../../services/AxiosInstance";


const JobList = () => {

  const [jobs, setJobs] = useState([]);

const toDateInputValue = (value) => {
  if (!value) return "";
  try {
    const d = value?._seconds ? new Date(value._seconds * 1000) : new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  } catch {
    return "";
  }
};

const formatExpiry = (value) => {
  if (!value) return "-";
  try {
    const d = value?._seconds ? new Date(value._seconds * 1000) : new Date(value);
    if (Number.isNaN(d.getTime())) return "-";
    return d.toLocaleDateString();
  } catch {
    return "-";
  }
};

  const [selectedJob, setSelectedJob] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 10;

  const [searchType, setSearchType] = useState("");
  const [searchValue, setSearchValue] = useState("");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filteredJobs, setFilteredJobs] = useState([]);

  const [isFiltered, setIsFiltered] = useState(false);

  const [toast, setToast] = useState("");
  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(""), 2500);
  };

  useEffect(()=>{
  fetchJobs();
  },[]);

 //  FETCH JOBS
const fetchJobs = async () => {
  try {
    const res = await Axios.get(`/api/jobs`);
    setJobs(res.data.data);
  } catch (error) {
    console.log("FETCH ERROR:", error.response);
  }
};

//USE EFFECT
useEffect(() => {
  refreshJobs();
}, []);


//  UPDATE JOB
const updateJob = async () => {
  try {
    const payload = { ...editData };
    delete payload.id;
    if (payload.expiryDate) {
      try {
        const d = payload.expiryDate?._seconds
          ? new Date(payload.expiryDate._seconds * 1000)
          : new Date(payload.expiryDate);
        if (!Number.isNaN(d.getTime()) && d > new Date()) payload.status = "active";
      } catch {
        // leave payload as-is; backend validates
      }
    }
    await Axios.put(`/api/jobs/${editData.id}`, payload);

    alert("Job Updated Successfully");
    setShowEditModal(false);
    fetchJobs();

  } catch (error) {
    console.log("UPDATE ERROR:", error.response);
  }
};


//  UPDATE JOB TYPE
const updateJobType = async (job, type) => {
  try {
    await Axios.put(`/api/jobs/${job.id}`, { jobType: type });

    setJobs(prev => prev.map(j => j.id === job.id ? { ...j, jobType: type } : j));
    setFilteredJobs(prev => prev.map(j => j.id === job.id ? { ...j, jobType: type } : j));

    showToast(`Job type updated to ${type === "public" ? "Public" : "Private"}`);
  } catch (error) {
    console.log("UPDATE JOB TYPE ERROR:", error.response);
    showToast("Failed to update job type");
  }
};


//  DELETE JOB
const deleteJob = async (id) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this job?");
  if (!confirmDelete) return;

  try {
    await Axios.delete(`/api/jobs/${id}`);

    alert("Job deleted successfully");
    fetchJobs();

  } catch (error) {
    console.log("DELETE ERROR:", error.response);
  }
};


//  FILTER JOBS
const handleFilter = async () => {
  try {
    let filtered = [...jobs];

    //  Search filter (API call)
    if (searchType && searchValue) {
      const res = await Axios.get(
        `/api/jobs/search?type=${searchType}&value=${searchValue}`
      );
      filtered = res.data.data;
    }

    //  Date filter (frontend)
    if (fromDate && toDate) {
      const start = new Date(fromDate);
      const end = new Date(toDate);
      end.setHours(23, 59, 59, 999);

      filtered = filtered
        .filter((job) => {
          if (!job.createdAt?._seconds) return false;

          const jobDate = new Date(job.createdAt._seconds * 1000);
          return jobDate >= start && jobDate <= end;
        })
        .sort((a, b) => {
          const timeA = a.createdAt?._seconds || 0;
          const timeB = b.createdAt?._seconds || 0;
          return timeA - timeB;
        });
    }

    setFilteredJobs(filtered);
    setIsFiltered(true);
    setCurrentPage(1);

  } catch (error) {
    console.log("FILTER ERROR:", error.response);
  }
};


//  REFRESH JOBS
const refreshJobs = async () => {
  try {
    const res = await Axios.get(`/api/jobs`);
    setJobs(res.data.data);

    setSearchType("");
    setSearchValue("");

  } catch (error) {
    console.log("REFRESH ERROR:", error.response);
  }
};


const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth", //  smooth animation
  });
};

const handleRemoveFilter = () => {
  //  reset all filters
  setSearchType("");
  setSearchValue("");

  setFromDate("");
  setToDate("");

  setFilteredJobs([]);
  setIsFiltered(false);

  // optional: reset pagination
  setCurrentPage(1);
};


const indexOfLastJob = currentPage * jobsPerPage;
const indexOfFirstJob = indexOfLastJob - jobsPerPage;
const currentJobs = jobs.slice(indexOfFirstJob, indexOfLastJob);

const totalPages = Math.ceil(jobs.length / jobsPerPage);

  
  return (

<div className="container-fluid mt-4">

<center><h2 className="job-title">JOB LIST</h2></center>

<div className="search-container">

  {/*  Search By */}
  <label><b>Search By :</b></label>

  <select
    value={searchType}
    onChange={(e) => setSearchType(e.target.value)}
    className="search-select"
  >
    <option value="">Select</option>
    <option value="jobId">Job ID</option>
    <option value="companyName">Company Name</option>
    <option value="techStack">Tech Stack</option>
  </select>

  <input
    type="text"
    placeholder="Search..."
    value={searchValue}
    onChange={(e) => setSearchValue(e.target.value)}
    className="search-input"
  />
<div className="date-filter-panel">

    <label><b>From Date :</b></label>
    <input
      type="date"
      value={fromDate}
      onChange={(e) => setFromDate(e.target.value)}
      className="form-control"
      style={{ marginRight: "8px", width: "140px", height: "30px", display: "inline-block" }}
    />

    <label><b>To Date :</b></label>
    <input
      type="date"
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
      className="form-control date-input"
      style={{ width: "140px", height: "30px", display: "inline-block" }}
    />

 <button className="search-btn" onClick={handleFilter}>
  Search
</button>
 <button className="btn btn-primary remove-btn" onClick={handleRemoveFilter}>
  Remove Filter
</button>
</div>

</div>

<table className="table table-bordered">

<thead className="table-dark">

<tr>
<th>S.No</th>
<th>Job ID</th>
<th>Company Name</th>
<th>Tech Stack</th>
<th>Description</th>
<th>Min Salary</th>
<th>Max Salary</th>
<th>Timeline</th>
<th>Experience</th>
<th>Created At</th>
<th>Expiry</th>
<th>Job Type</th>
<th>Action</th>
</tr>

</thead>


<tbody>

{jobs.length === 0 ? (

<tr>
<td colSpan="12" style={{ textAlign: "center" }}>
No Jobs Found
</td>
</tr>

) : (

isFiltered ? (

  filteredJobs.length > 0 ? (

    filteredJobs.map((job, index) => (

<tr key={job.id}>

<td>{index + 1}</td>

<td>{job.jobId}</td>

<td style={{ maxWidth: "150px", wordBreak: "break-word", whiteSpace: "normal" }}>
{job.companyName}
</td>

<td style={{ maxWidth: "200px", wordBreak: "break-word", whiteSpace: "normal" }}>
{job.techStack}
</td>

<td style={{ maxWidth: "250px", wordBreak: "break-word", whiteSpace: "normal" }}>
{job.jobDescription}
</td>

<td>{job.minSalary}</td>

<td>{job.maxSalary}</td>

<td>{job.timeline}</td>

<td>{job.experience || "-"}</td>

<td>
{job.createdAt
? new Date(job.createdAt._seconds * 1000).toLocaleDateString()
: "-"}
</td>

<td>{formatExpiry(job.expiryDate)}</td>

<td>
<select
  className="form-control"
  value={job.jobType || "private"}
  onChange={(e) => updateJobType(job, e.target.value)}
>
  <option value="private">Private</option>
  <option value="public">Public</option>
</select>
</td>

<td>

<div className="d-flex flex-column action-btns">

  <div className="d-flex">
    <button
      className="btn btn-info btn-sm"
      onClick={() => {
        setSelectedJob(job);
        setShowModal(true);
      }}
    >
      View
    </button>

    <button
      className="btn btn-warning btn-sm"
      onClick={() => {
        setEditData({ ...job, expiryDate: toDateInputValue(job.expiryDate) });
        setShowEditModal(true);
      }}
    >
      Edit
    </button>
  </div>

  <div className="d-flex">
    <button
      className="btn btn-danger btn-sm"
      onClick={() => deleteJob(job.id)}
    >
      Delete
    </button>

    <button className="btn btn-primary btn-sm">
      Apply
    </button>
  </div>

</div>

</td>

</tr>

    ))

  ) : (

    <tr>
      <td colSpan="12" style={{ textAlign: "center" }}>
        ❌ NO JOBS AVAILABLE
      </td>
    </tr>

  )

) : (

  currentJobs.map((job, index) => (

<tr key={job.id}>


<td>{indexOfFirstJob + index + 1}</td>

<td>{job.jobId}</td>

<td style={{ maxWidth: "150px", wordBreak: "break-word", whiteSpace: "normal" }}>
{job.companyName}
</td>

<td style={{ maxWidth: "200px", wordBreak: "break-word", whiteSpace: "normal" }}>
{job.techStack}
</td>

<td style={{ maxWidth: "250px", wordBreak: "break-word", whiteSpace: "normal" }}>
{job.jobDescription}
</td>

<td>{job.minSalary}</td>

<td>{job.maxSalary}</td>

<td>{job.timeline}</td>

<td>{job.experience || "-"}</td>

<td>
{job.createdAt
? new Date(job.createdAt._seconds * 1000).toLocaleDateString()
: "-"}
</td>

<td>{formatExpiry(job.expiryDate)}</td>

<td>
<select
  className="form-control"
  value={job.jobType || "private"}
  onChange={(e) => updateJobType(job, e.target.value)}
>
  <option value="private">Private</option>
  <option value="public">Public</option>
</select>
</td>

<td>

<div className="d-flex flex-column action-btns">

  <div className="d-flex">
    <button
      className="btn btn-info btn-sm"
      onClick={() => {
        setSelectedJob(job);
        setShowModal(true);
      }}
    >
      View
    </button>

    <button
      className="btn btn-warning btn-sm"
      onClick={() => {
        setEditData({ ...job, expiryDate: toDateInputValue(job.expiryDate) });
        setShowEditModal(true);
      }}
    >
      Edit
    </button>
  </div>

  <div className="d-flex">
    <button
      className="btn btn-danger btn-sm"
      onClick={() => deleteJob(job.id)}
    >
      Delete
    </button>

    <button className="btn btn-primary btn-sm">
      Apply
    </button>
  </div>

</div>

</td>

</tr>

  ))

)

)}

</tbody>
</table>

{(isFiltered ? filteredJobs.length > 0 : jobs.length > 0) && (

<div className="d-flex justify-content-center mt-3">

<button
className="btn btn-dark me-2"
disabled={currentPage === 1}
onClick={() => setCurrentPage(currentPage - 1)}
>
Previous
</button>

<span className="mt-2 mx-2">
Page {currentPage} of {totalPages}
</span>

<button
className="btn btn-dark ms-2"
disabled={currentPage === totalPages}
onClick={() => setCurrentPage(currentPage + 1)}
>
Next
</button>

</div>

)}


{showEditModal && (

<div style={{
position:"fixed",
top:0,
left:0,
width:"100%",
height:"100%",
background:"rgba(0,0,0,0.5)",
display:"flex",
justifyContent:"center",
alignItems:"center"
}}>

<div style={{
background:"white",
padding:"25px",
borderRadius:"8px",
width:"400px"
}}>

<h4>Edit Job</h4>

<input
className="form-control mb-2"
value={editData.companyName || ""}
onChange={(e)=>setEditData({...editData,companyName:e.target.value})}
/>

<input
className="form-control mb-2"
value={editData.techStack || ""}
onChange={(e)=>setEditData({...editData,techStack:e.target.value})}
/>

<textarea
className="form-control mb-2"
value={editData.jobDescription || ""}
onChange={(e)=>setEditData({...editData,jobDescription:e.target.value})}
/>

<input
className="form-control mb-2"
value={editData.minSalary || ""}
onChange={(e)=>setEditData({...editData,minSalary:e.target.value})}
/>

<input
className="form-control mb-2"
value={editData.maxSalary || ""}
onChange={(e)=>setEditData({...editData,maxSalary:e.target.value})}
/>

<label className="mb-1"><b>Last Date to Apply</b></label>
<input
type="date"
className="form-control mb-2"
value={editData.expiryDate || ""}
min={new Date().toISOString().slice(0, 10)}
onChange={(e)=>setEditData({...editData,expiryDate:e.target.value})}
/>

<button
className="btn btn-success"
onClick={updateJob}
>
Update
</button>

<button
className="btn btn-danger ms-2"
onClick={()=>setShowEditModal(false)}
>
Cancel
</button>


</div>

</div>

)}

<button className="top-up-btn" onClick={scrollToTop}>
  ⬆ Top 
</button>

{toast && (
<div style={{
  position: "fixed",
  bottom: "65px",
  right: "20px",
  background: "#28a745",
  color: "white",
  padding: "12px 20px",
  borderRadius: "6px",
  boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
  zIndex: 2000
}}>
  {toast}
</div>
)}


{/*  VIEW MODAL */}

{showModal && selectedJob && (
<div style={{
position: "fixed",
top: 0,
left: 0,
width: "100%",
height: "100%",
background: "rgba(0,0,0,0.5)",
display: "flex",
justifyContent: "center",
alignItems: "center",
zIndex: 1000
}}>

<div style={{
  background: "white",
  padding: "25px",
  borderRadius: "8px",
  width: "400px"
}}>

<h4>Job Details</h4>

<p><b>Job ID:</b> {selectedJob.jobId}</p>
<p><b>Company Name:</b> {selectedJob.companyName}</p>
<p><b>Tech Stack:</b> {selectedJob.techStack}</p>

<p>
  <b>Description:</b>
  <span style={{
    display: "block",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    whiteSpace: "normal",
    maxHeight: "120px",
    overflowY: "auto",
    marginTop: "5px"
  }}>
    {selectedJob.jobDescription}
  </span>
</p>

<p><b>Min Salary:</b> {selectedJob.minSalary}</p>
<p><b>Max Salary:</b> {selectedJob.maxSalary}</p>
<p><b>Timeline:</b> {selectedJob.timeline}</p>
<p><b>Experience:</b> {selectedJob.experience || "-"}</p>
<p><b>Expiry:</b> {formatExpiry(selectedJob.expiryDate)}</p>

<button
  className="btn btn-danger mt-2"
  onClick={() => setShowModal(false)}
>
  Close
</button>

</div>

</div>

)}

</div>

);


};

export default JobList;